import Swiper from 'swiper';
import { createMask } from '../components/phone';
import { Modal } from '../components/modal';
import { Metrika } from '../components/metrika';

export function bilet() {
  const modal = new Modal;
    const metrika = new Metrika;
    let quizInfo = '';
    let phonesInputs = document.querySelectorAll('[data-phoneMask]');
    phonesInputs.forEach( item => {
        createMask(item)
    });

    let inputs = document.querySelectorAll('[am-input]');
    let formError = document.querySelectorAll('[am-error]');
    inputs.forEach( item => {
        item.addEventListener('input', () => {
            item.classList.remove('error');

            formError.forEach( elem => {
                elem.classList.remove('is-active');
            });
        });
    });

    const forms = document.querySelectorAll('.js-FeedbackForm');

    forms.forEach( form => {
      const type = form.dataset.type;

      // Цели - ввод данных в инпуты
      const inputName = form.querySelector('input[name="fio"]');
      const inputPhone = form.querySelector('input[name="phone"]');

      inputName.addEventListener('change', function() {
          if (type == 'modal') {
              metrika.reachGoal('input_name_in_popup_order', this);
          } else if (type == 'modal_offer') {
              metrika.reachGoal('input_name_in_intro_order', this);
          }
      });

      inputPhone.addEventListener('change', function() {
          if (type == 'modal') {
              metrika.reachGoal('input_phone_in_popup_order', this);
          } else if (type == 'modal_offer') {
              metrika.reachGoal('input_phone_in_intro_order', this);
          }
      });

      form.addEventListener('submit', e => {
          e.preventDefault();
          // От повторных кликов
          const btn = form.querySelector('button');
          btn.setAttribute('disabled', '');

          // Данные для отправки
          const formData = new FormData();
          const fio = form.querySelector('input[name="fio"]').value;
          const phone = form.querySelector('input[name="phone"]').value;
          const comment = form.querySelector('textarea');
          const current_page = document.querySelector('input[name="current_page"]').value;

          if (comment) {
              formData.append('comment', comment.value);
          }

          formData.append('fio', fio);
          formData.append('phone', phone);
          formData.append('current_page', current_page);
          formData.append('quizInfo', quizInfo);

          // Отправка
          // fetch('/handler/send_feedback ', {
          //     method: 'POST',
          //     headers: {
          //         'X-Requested-With': 'XMLHttpRequest',
          //     },
          //     body: formData,
          // })
          // .then(response => response.json())
          // .then(r => {
          //     btn.removeAttribute('disabled');
          //     // console.log(r);
          //     if (r.status == 'ok') {

          //         // Цели - отправка формы
          //         if (type == 'modal') {
          //             metrika.reachGoal('submit_popup_order', form);
          //         } else if (type == 'modal_offer') {
          //             metrika.reachGoal('submit_intro_order', form);
          //         } else if (type == 'modal_help') {
          //             metrika.reachGoal('submit_needhelp_order', form);
          //         } else if (type == 'modal_question') {
          //             metrika.reachGoal('submit_questleft_order', form);
          //         }

          //         const activeModal = document.querySelector('[am-block="modal"].is-active');

          //         if (activeModal) {
          //             activeModal.classList.remove('is-active');
          //             document.body.style.overflow = '';
          //             document.documentElement.style.overflow = '';
          //         }

          //         modal.open('modal', 'thx', 'close');
          //         form.querySelector('input[name="fio"]').value = '';
          //         form.querySelector('input[name="phone"]').value = '';
          //     }

          //     if (r.status == 'error') {
          //         const errorText = form.querySelector('.js-formErrorText');
          //         errorText.textContent = r.message;
          //         errorText.classList.add('is-active');

          //         r.fields.forEach(name => {
          //               form.querySelector(`input[name="${name}"]`).classList.add('error');
          //         })
          //     }
          // })
      })
  })

  const questionNextBtn = document.querySelectorAll('.next-btn')
  const questionPrevBtn = document.querySelectorAll('.prev-btn')


  let counter = 0;
  questionNextBtn.forEach((nextBtn) => {
    nextBtn.addEventListener('click', () => {
      counter = 0;
      let questionBlocks = document.querySelectorAll('.question-block2')
      questionBlocks.forEach((curBlock) => {
        if (curBlock.getAttribute('data-step') == nextBtn.getAttribute('data-step')) {
          if (curBlock.getAttribute('data-step') == 16) {
          } else {
            let blockVariants = curBlock.querySelector('.variant-block.active-answer');
            if (blockVariants) {
                counter++;
            }
            if (counter > 0) {
                curBlock.classList.add('hidden')
            }
            questionBlocks.forEach((block) => {
              if (block.getAttribute('data-step') == (Number(nextBtn.getAttribute('data-step')) + 1)) {
                if (counter > 0) {
                    block.classList.remove('hidden');
                    if (Number(nextBtn.getAttribute('data-step')) == 1) {
                        quizInfo += 'Оценка состояния здоровья : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 2) {
                        quizInfo += 'Боли в области спины : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 3) {
                        quizInfo += 'Затекает ли спина, если сидеть более 30мин : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 4) {
                        quizInfo += 'Болят ли суставы : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 5) {
                        quizInfo += 'Дискомфорт стоп при ношении обуви : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 6) {
                        quizInfo += 'Кружится ли голова : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 7) {
                        quizInfo += 'Бывают ли головные боли : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 8) {
                        quizInfo += 'Хорошо ли спит : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 9) {
                        quizInfo += 'Как часто заложен нос : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 10) {
                        quizInfo += 'Бывает ли изжога : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 11) {
                        quizInfo += 'Бывает ли тошнота : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 12) {
                        quizInfo += 'Бывают ли боли в животе : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 13) {
                        quizInfo += 'Есть ли родинки на голове, шее, плечах, поясе в местах соприкосновения с одеждой : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 14) {
                        quizInfo += 'Есть ли прыщи на коже : ';
                    } else if (Number(nextBtn.getAttribute('data-step')) == 15) {
                        quizInfo += 'Есть ли высыпания/пятна на коже : ';
                    }
                    quizInfo += document.querySelector('.question-block2 .variant-block.active-answer .text').textContent + '<br /><br />';
                } else {
                    alert('Выберите один из ответов');
                }
              }
            })
          }
        }
      })
    })
  })
  let limiter = 0;
  document.querySelectorAll('.question-block2[data-step="16"] .variant-block').forEach((lastblock) => {
    lastblock.addEventListener('click', (e) => {
        document.querySelector('.last-btn').setAttribute('data-open', 'feedback');
        document.querySelector('.last-btn[data-open="feedback"]').addEventListener('click', (e) => {
                if (limiter == 0) {
                    quizInfo += 'Зрение : ';
                    quizInfo += document.querySelector('.question-block2[data-step="16"] .variant-block.active-answer .text').textContent + '<br />';
                    limiter++;
                }
        })
    })
  })

if (document.querySelector('.last-btn[data-open="empty"]')) {
    document.querySelector('.last-btn[data-open="empty"]').addEventListener('click', (e) => {
        if (document.querySelector('.last-btn').getAttribute('data-open') == "empty") {
            alert('Выберите один из ответов');
        }
    })
}


  questionPrevBtn.forEach((prevBtn) => {
    prevBtn.addEventListener('click', () => {
      let questionBlocks = document.querySelectorAll('.question-block2')
      questionBlocks.forEach((curBlock) => {
        if (curBlock.getAttribute('data-step') == prevBtn.getAttribute('data-step')) {
          curBlock.classList.add('hidden')
          questionBlocks.forEach((block) => {
            if (block.getAttribute('data-step') == (Number(prevBtn.getAttribute('data-step')) - 1)) {
              block.classList.remove('hidden')
            }
          })
        }
      })
    })
  })
}
